import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './app';
import { loadWhitelabel } from './whitelabel/config';
// import initSentry from './init-sentry';

// initSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Carregar whitelabel antes de renderizar a aplicação
loadWhitelabel().finally(() => {
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
});
